import { useSyncExternalStore } from 'react';
import { useFramework } from '@/framework';
import type { TextEditorPlugin } from '../manager';

export const useSession = () => {
    const framework = useFramework();
    const editor = framework.service.registration.getInstance<TextEditorPlugin>('TextEditorPlugin');

    return useSyncExternalStore(
        (callback) => editor.onSessionChange(callback),
        () => editor.getSession(),
        () => null,
    );
};
